<div class="h-100" [ngStyle]="contentStyle">
  @if (isAirwallexProvider()) {
  <div>
    @if (iframeError) {
    <div>{{ iframeError }}</div>
    }
    <div [id]="iframeHostId"></div>
  </div>
  } @else {
  {{ ePin }}
  }
</div>
